const initialState = {
  presignedUrl: null,
  uploadResult: null,
  deleteResult: null,
  existsResult: null,
  downloadResult: null,
  loading: false,
  uploadLoading: false,
  deleteLoading: false,
  existsLoading: false,
  downloadLoading: false,
  error: null,
};

export default function storageReducer(state = initialState, action) {
  switch (action.type) {
    case 'STORAGE_PRESIGNED_URL_REQUEST':
      return { ...state, loading: true, error: null };
    case 'STORAGE_PRESIGNED_URL_SUCCESS':
      return { ...state, loading: false, presignedUrl: action.payload };
    case 'STORAGE_PRESIGNED_URL_FAILURE':
      return { ...state, loading: false, error: action.error };

    case 'STORAGE_UPLOAD_REQUEST':
      return { ...state, uploadLoading: true, error: null };
    case 'STORAGE_UPLOAD_SUCCESS':
      return { ...state, uploadLoading: false, uploadResult: action.payload };
    case 'STORAGE_UPLOAD_FAILURE':
      return { ...state, uploadLoading: false, error: action.error };

    case 'STORAGE_DELETE_REQUEST':
      return { ...state, deleteLoading: true, error: null };
    case 'STORAGE_DELETE_SUCCESS':
      return { ...state, deleteLoading: false, deleteResult: action.payload };
    case 'STORAGE_DELETE_FAILURE':
      return { ...state, deleteLoading: false, error: action.error };

    case 'STORAGE_EXISTS_REQUEST':
      return { ...state, existsLoading: true, error: null };
    case 'STORAGE_EXISTS_SUCCESS':
      return { ...state, existsLoading: false, existsResult: action.payload };
    case 'STORAGE_EXISTS_FAILURE':
      return { ...state, existsLoading: false, error: action.error };

    case 'STORAGE_DOWNLOAD_REQUEST':
      return { ...state, downloadLoading: true, error: null };
    case 'STORAGE_DOWNLOAD_SUCCESS':
      return { ...state, downloadLoading: false, downloadResult: action.payload };
    case 'STORAGE_DOWNLOAD_FAILURE':
      return { ...state, downloadLoading: false, error: action.error };

    default:
      return state;
  }
}
